import {BrowserRouter, Route, Routes} from "react-router-dom";
import React from "react";
import PageFiles from "./page/pageFiles/PageFiles";
import Login from "./page/auth/login/Login";
import Registration from "./page/registration/Registration";
import Header from "./page/header/Header";
import PageCameras from "./page/cameras/PageCameras";
import PageHome from "./page/home/PageHome";
import {config} from "./config";
import PageProfile from "./page/profile/PageProfile";
import PageNotFound from "./page/notFound/PageNotFound";
import PageMain from "./page/main/PageMain";
import PublicHeader from "./page/header/PublicHeader";
import PublicPageFiles from "./page/pageFiles/PublicPageFiles";
import PageSettings from "./page/settings/PageSettings";
import FormCodePage from "./page/formCode/FormCodePage";
import BirthdayPage from "./page/birthday/BirthdayPage";

const RoutNavigation = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path={`${config.uiStart}/public/`} element={<PublicHeader/>}>
                    <Route index path={`${config.uiStart}/public/files/:publicId`} element={<PublicPageFiles/>}/>
                    <Route index path={`${config.uiStart}/public/files/:publicId/:id`} element={<PublicPageFiles/>}/>
                    <Route path={`${config.uiStart}/public/*`} element={<PageNotFound/>} />
                </Route>
                <Route path={`${config.uiStart}/`} element={<Header/>}>
                    <Route index path={`${config.uiStart}/`} element={<PageMain/>}/>
                    <Route index path={`${config.uiStart}/files`} element={<PageFiles/>}/>
                    <Route path={`${config.uiStart}/cameras`} element={<PageCameras/>}/>
                    <Route path={`${config.uiStart}/smart-home`} element={<PageHome/>}/>
                    <Route path={`${config.uiStart}/profile`} element={<PageProfile/>}/>
                    <Route path={`${config.uiStart}/settings`} element={<PageSettings/>}/>
                    <Route path={`${config.uiStart}/birthday`} element={<BirthdayPage/>}/>
                    <Route path={`${config.uiStart}/:id`} element={<PageFiles/>}/>

                    {/*<Route path="password" element={<PasswordPage/>}/>*/}
                    {/*<Route path="group/:id" element={<PurchaseList/>}/>*/}
                    <Route path={`${config.uiStart}/*`} element={<PageNotFound/>} />
                </Route>
                <Route  path={`${config.uiStart}/auth`} element={<Login/>}/>
                <Route  path={`${config.uiStart}/code`} element={<FormCodePage/>}/>
                <Route  path={`${config.uiStart}/registration`} element={<Registration/>}/>
                {/*<Route  path={"/public/group/:id"} element={<PublicList/>}/>*/}
            </Routes>
        </BrowserRouter>
    )
}

export default RoutNavigation
